import axios from 'axios'

const API = "biblioteca"

const ENDPOINTS = {
    getCarpetas(){
        return axios.get(`${API}/listado`)
    },
   
    crearCarpeta(form){
        return axios.post(`${API}/crear`,form)
    },
    editarCarpeta(form){
        return axios.put(`${API}/carpeta/${form.id}/edit`,form)
    },
    eliminarCarpeta(id){
        return axios.delete(`${API}/carpeta/${id}/eliminar`)
    },
    getDocumentos(idCarpeta){
        return axios.get(`${API}/${idCarpeta}/docs`)
    },
    subirDocumento(form){
        return axios.post(`${API}/upload/file`,form)
    },
    eliminarDocumento(id){
        return axios.delete(`${API}/documento/${id}/eliminar`)
    }
}
export default ENDPOINTS